/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

import { HistoryTab, HistoryFiatCryptoTab } from "@/shared/constants/enums";
import {
  HistoryFilterRequest,
  AdminHistoryFilterRequest,
  Search,
} from "@/shared/constants/interfaces";
import { SearchFactory } from "@/shared/factory/search";
import { HistoryFilterRequestFactory } from "@/shared/factory/history";

enum HistoryMutation {
  UPDATE_FILTER = "UPDATE_FILTER",
  UPDATE_ADMIN_FILTER = "UPDATE_ADMIN_FILTER",
  CLEAR_FILTER = "CLEAR_FILTER",
  UPDATE_TAB = "UPDATE_TAB",
  UPDATE_FIAT_CRYPTO_TAB = "UPDATE_FIAT_CRYPTO_TAB",
  UPDATE_IS_FILTER = "UPDATE_IS_FILTER",
  UPDATE_SEARCH_VALUE = "UPDATE_SEARCH_VALUE",
  ADD_PAGE = "ADD_PAGE",
  CLEAR_PAGE = "CLEAR_PAGE",
  CLEAR_TYPE = "CLEAR_TYPE",
}

interface State {
  filter?: HistoryFilterRequest;
  adminFilter?: AdminHistoryFilterRequest;
  tab?: HistoryTab;
  isFilter?: boolean;
  search?: Search;
  isLoading?: boolean;
}

@Module({
  namespaced: true,
  stateFactory: true,
  name: "history",
})
export default class HistoryModuleState extends VuexModule<State> {
  filter: HistoryFilterRequest = HistoryFilterRequestFactory();
  adminFilter: AdminHistoryFilterRequest = HistoryFilterRequestFactory();
  tab: HistoryTab = HistoryTab.depositWithdrawal;
  tabFiatCrypto: HistoryFiatCryptoTab = HistoryFiatCryptoTab.fiat;
  isFilter: boolean = false;
  search: Search = SearchFactory();

  @Mutation
  [HistoryMutation.UPDATE_FILTER](filter: HistoryFilterRequest): void {
    this.filter = filter;
  }

  @Mutation
  [HistoryMutation.UPDATE_ADMIN_FILTER](
    adminFilter: AdminHistoryFilterRequest
  ): void {
    this.adminFilter = adminFilter;
  }

  @Mutation
  [HistoryMutation.CLEAR_FILTER](): void {
    this.filter = HistoryFilterRequestFactory();
  }

  @Mutation
  [HistoryMutation.UPDATE_TAB](tab: HistoryTab): void {
    this.tab = tab;
  }

  @Mutation
  [HistoryMutation.UPDATE_FIAT_CRYPTO_TAB](tab: HistoryFiatCryptoTab): void {
    this.tabFiatCrypto = tab;
  }

  @Mutation
  [HistoryMutation.UPDATE_IS_FILTER](isFilter: boolean): void {
    this.isFilter = isFilter;
  }

  @Mutation
  [HistoryMutation.UPDATE_SEARCH_VALUE](value: string): void {
    this.search.value = value;
  }

  @Mutation
  [HistoryMutation.ADD_PAGE](): void {
    this.filter.page += 1;
  }

  @Mutation
  [HistoryMutation.CLEAR_PAGE](): void {
    this.filter.page = 1;
  }

  @Mutation
  [HistoryMutation.CLEAR_TYPE](): void {
    this.filter.type = "";
  }
}
